(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naturalmind-salt-lp"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-salt-approved]').forEach((root) => {
    const normal = root.querySelector('input[value="normal"]');
    const subscription = root.querySelector('input[value="subscription"]');
    const cycle = root.querySelector('[data-cycle]');
    const sellingPlan = root.querySelector('[data-selling-plan]');
    const offer = root.querySelector('[data-offer]');
    const priceCurrent = root.querySelector('[data-price-current]');
    const priceRegular = root.querySelector('[data-price-regular]');
    const subscriptionPrice = root.querySelector('[data-subscription-price]');

    const syncCycle = () => {
      if (!sellingPlan || !cycle) return;
      sellingPlan.value = cycle.value;
      if (subscriptionPrice && cycle.selectedOptions[0]?.dataset.money) {
        subscriptionPrice.textContent = `${cycle.selectedOptions[0].dataset.money}（税込）`;
      }
    };

    const updateMode = () => {
      const isSubscription = subscription?.checked;
      cycle.disabled = !isSubscription;
      sellingPlan.disabled = !isSubscription || !cycle.value;
      offer.hidden = !isSubscription;
      priceRegular.hidden = !isSubscription;
      if (isSubscription) {
        syncCycle();
        if (cycle.selectedOptions[0]?.dataset.money) priceCurrent.textContent = cycle.selectedOptions[0].dataset.money;
      } else {
        priceCurrent.textContent = priceRegular.textContent.replace('通常 ', '');
      }
    };

    normal?.addEventListener('change', updateMode);
    subscription?.addEventListener('change', updateMode);
    cycle?.addEventListener('change', () => {
      syncCycle();
      if (subscription?.checked && cycle.selectedOptions[0]?.dataset.money) priceCurrent.textContent = cycle.selectedOptions[0].dataset.money;
    });
    updateMode();
  });

  } catch(e) { console.error(e); }
})();
})();
